// Timer Start ===============================

const progressBar = document.getElementById("progress-bar");

class FlexibleTimer {
  constructor(
    callback,
    progressBarId = null
  ) {
    this.callback = callback; // Function to call when the timer completes
    this.remainingTime = 0; // Time left in milliseconds
    this.startTime = 0; // Timestamp when the timer starts or resumes
    this.timerId = null; // Reference to the timer
    this.isRunning = false; // Timer state
    this.totalDuration = 0; // Total duration of the timer
    this.progressBar = progressBarId
      ? document.getElementById(progressBarId)
      : null; // Reference to the progress bar element

    this.updateProgressBar();
  }

  // Start or resume the timer
  start(duration = null) {
      if (duration !== null) {
          this.remainingTime = duration;
          this.totalDuration = duration; // Save the total duration for progress calculations
      }

      // console.log(`start this.remainingTime = ${this.remainingTime}`);
      if (this.remainingTime <= 0) {
        // this.end();
        // console.error("Timer duration must be greater than 0");
        return;
      }

      if (this.isRunning) {
          // console.warn("Timer is already running");
          return;
      }

      // console.info('timer start');

      this.startTime = Date.now();
      this.isRunning = true;

      this.timerId = setInterval(() => {
        const remaining = this.getRemainingTime();
        if (remaining <= 0) {
          this.end();
        } else {
          // console.log(`remaining = ${remaining}`);
          // console.log(`this.remainingTime = ${this.remainingTime}`);
          this.updateProgressBar();
        }
      }, 100); // Update the progress bar every 100ms
  }

  end() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }

    this.isRunning = false;
    this.remainingTime = 0;

    if (this.callback) {
      this.callback();
    }

    this.updateProgressBar();
  }

  // Pause the timer
  pause() {
      if (!this.isRunning) {
          // console.warn("Timer is not running");
          return;
      }

      // console.info('timer pause');

      clearInterval(this.timerId);
      this.isRunning = false;
      this.remainingTime -= Date.now() - this.startTime;
      this.updateProgressBar();
  }

  // Reset the timer with a new duration
  reset(newDuration) {
      this.pause(); // Stop the current timer
      this.remainingTime = newDuration;
      this.totalDuration = newDuration;
      this.updateProgressBar();
  }

  // Check the remaining time in milliseconds
  getRemainingTime() {
      if (this.isRunning) {
          return this.remainingTime - (Date.now() - this.startTime);
      }
      return this.remainingTime;
  }

  // Stop the timer completely
  stop() {
      clearInterval(this.timerId);
      this.isRunning = false;
      this.remainingTime = 0;
      this.updateProgressBar();
  }

  // Update the width of the progress bar
  updateProgressBar() {
      if (this.progressBar) {
          const remaining = this.getRemainingTime();
          let percentage = 0;

          if (remaining > 0) {
            percentage = ((this.totalDuration - remaining) / this.totalDuration) * 100;
          }

          this.progressBar.style.width = `${percentage}%`;
      }
  }
}

// Timer End ==================================

// Slideshow Start ============================

// Add event listeners for interaction on the .siema element
const elementSlideshowWrap = document.querySelector('.slideshow-wrap');
const elementSlideshow = document.querySelector('.slideshow');
const elementSlideshowPrev = document.querySelector('#slideshow-prev');
const elementSlideshowNext = document.querySelector('#slideshow-next');

const SLIDESHOW_AUTO_DELAY = 5000;
const SLIDESHOW_AUTO_DELAY_INTERACTED = 10000;
const SLIDESHOW_AUTO_DELAY_MIN = 2000;

class Slideshow {
  constructor() {
    this.interacted = false;

    // Bind methods to ensure correct context
    this.onSlideshowSlideChange = this.onSlideshowSlideChange.bind(this);
    this.onTimerComplete = this.onTimerComplete.bind(this);
    this.timerStart = this.timerStart.bind(this);
    this.onSlideshowInit = this.onSlideshowInit.bind(this);

    // Initialize the FlexibleTimer
    this.timer = new FlexibleTimer(this.onTimerComplete, "slideshow-progress");

    // Initialize Siema with bound methods
    this.slideshowSiema = new Siema({
      selector: '.slideshow',
      duration: 500,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 50,
      loop: true,
      rtl: false,
      onInit: this.onSlideshowInit,
      onChange: this.onSlideshowSlideChange.bind(this)
    });
  };

  // Slideshow Timer Start ======================

  timerStart(duration = 0) {
    if (!this.timer) {
      return;
    }

    if (duration > 0) {
      this.timer.start(duration);
      return;
    }

    if (this.timer.remainingTime > 0) {
      if (this.timer.remainingTime < SLIDESHOW_AUTO_DELAY_MIN) {
        this.timer.remainingTime = SLIDESHOW_AUTO_DELAY_MIN;
      }
      this.timer.start();
    }
    else {
      this.timer.start(SLIDESHOW_AUTO_DELAY);
      this.interacted = false;
    }
  }

  timerPause() {
    if (this.timer) {
      this.timer.pause();
    }
  }

  onTimerComplete() {
    // console.log("Timer completed!");
    this.slideshowSiema.next();
    this.timerStart();
  }

  // Slideshow Timer End ========================

  onSlideshowSlideChange() {
    // console.log(`Slide Selector: ${this.slideshowSiema.config.selector}, Current Slide: ${this.slideshowSiema.currentSlide}`);
    if (typeof window.refreshButtonMediaImageEffects === 'function') {
      window.refreshButtonMediaImageEffects();
    }
  }

  onSlideshowInit() {
    elementSlideshow.classList.remove('slideshow--init');
    if (typeof window.refreshButtonMediaImageEffects === 'function') {
      window.refreshButtonMediaImageEffects();
    }
    this.timerStart();
  }

  onSlideshowInteract() {
    this.interacted = true;

    if (this.timer) {
      this.timer.reset(SLIDESHOW_AUTO_DELAY_INTERACTED);
    }
  }

  slideshowButtonAction(action) {
    this.onSlideshowInteract();

    action(); // Perform the action (e.g., `slideshowSiema.prev()` or `slideshowSiema.next()`)
  }
}

const mySlideshow = new Slideshow();

function slideshowTimerPause() {
  // console.log('mouseover wrap');
  mySlideshow.timerPause();
}

function slideshowTimerStart(duration = 0) {
  // console.log('mouseout wrap');
  if (duration > 0) {
    mySlideshow.timerStart(duration);
  }
  mySlideshow.timerStart();
}

// Slideshow End ==============================

// Swipe Detection Start =====================

// Swipe detection variables
const SWIPE_THRESHOLD = 1; // Minimum movement to consider it a swipe

let isInteraction = false; // Tracks if a click or press is active
let interactionXInit = 0; // Starting X position of a touch/mouse event
let isInteractionSwipe = false; // Tracks whether a swipe is in progress

function setIsInteractionSwipe(value) {
  isInteractionSwipe = value; // Set swipe status

  // console.log(`isInteractionSwipe = ${isInteractionSwipe}`);

  if (isInteractionSwipe) {
    elementSlideshowWrap.classList.add('slideshow--swipe');
  } else {
    elementSlideshowWrap.classList.remove('slideshow--swipe');
  }
}

function getEventInteract(event) {
  return event.touches ? event.touches[0] : event;
}

// Detect the start of a interaction event
function handleInteractStart(event) {
  // Update interacting state
  if (event.type === 'mousedown' || event.type === 'touchstart') {
    isInteraction = true;
    interactionXInit = getEventInteract(event).clientX;
  }

  // console.log('[Swipe] Start');
  setIsInteractionSwipe(false);

  slideshowTimerPause();
}

// Detect the movement during a touch/mouse event
function handleInteractMove(event) {
  if (!isInteraction || isInteractionSwipe) return; // Only proceed if an interaction, and not a swipe, is active

  const deltaX = getEventInteract(event).clientX - interactionXInit;

  // Check if the movement is more horizontal than vertical and exceeds the threshold
  if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
    // console.log('[Swipe] Move');
    setIsInteractionSwipe(true);
  }
}

function isInteractLink(event) {
  let target = event.target;

  // Traverse up the DOM to check for parent <a> tag
  while (target && target !== elementSlideshow) {
    if (target.tagName.toLowerCase() === 'a') {
      return true; // Exit the while after preventing the click
    }

    target = target.parentElement;
  }

  return false;
}

function handleSwipeEnd(event) {
  // Prevent clicks on links if a swipe occurred
  if (isInteractionSwipe) {
    if (isInteractLink(event)) {
      event.preventDefault(); // Prevent default click behavior
      event.stopPropagation(); // Stop the event from propagating further

      // console.warn('Click on link prevented');
    }

    setIsInteractionSwipe(false);

    // console.warn('No clickable link detected');
  }
}

// Detect the end of a touch/mouse event
function handleInteractEnd(event) {
  // console.log('[Swipe] End');
  handleSwipeEnd(event);

  if (isInteraction) {
    mySlideshow.onSlideshowInteract();
  }

  isInteraction = false;
}

// Swipe Detection End =========================

// Event Listeners Begin =======================

// Event Listeners Wrap Begin ==================

function isEventOnElement(element, event) {
  return !element.contains(event.relatedTarget);
}

// Utility function to check for touch support
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

elementSlideshowWrap.addEventListener('mouseover', (event) => {
  // alert("mouseover");
  if (isTouchDevice() || !isEventOnElement(elementSlideshowWrap, event)) {
    return;
  }

  // alert("mouseover");
  slideshowTimerPause();
});

elementSlideshowWrap.addEventListener('mouseout', (event) => {
  if (!isEventOnElement(elementSlideshowWrap, event)) {
    return;
  }

  // alert("mouseout");
  handleInteractEnd(event);
  slideshowTimerStart();
});

// elementSlideshowWrap.addEventListener('focusin', (event) => {
// });

// elementSlideshowWrap.addEventListener('focusout', (event) => {
// });

function handleInteractEndTouch(event) {
  if (!isEventOnElement(elementSlideshowWrap, event)) {
    return;
  }
  // alert("touchend");

  handleInteractEnd(event);
  slideshowTimerStart();
}

// Event Listeners Wrap End ====================

// Attach event listeners for swipe detection
elementSlideshow.addEventListener('touchstart', handleInteractStart);
elementSlideshow.addEventListener('touchmove', handleInteractMove);
elementSlideshow.addEventListener('touchend', handleInteractEndTouch);

elementSlideshow.addEventListener('mousedown', handleInteractStart);
elementSlideshow.addEventListener('mousemove', handleInteractMove);
// elementSlideshow.addEventListener('mouseup', handleInteractEnd);

elementSlideshow.addEventListener('click', handleInteractEnd);

// Event Listeners Buttons Begin ===============

function handleButtonAction(action) {
  return () => {
    mySlideshow.slideshowButtonAction(() => action());
  
    if (!isTouchDevice()) {
      return;
    }
  
    slideshowTimerStart();
  };
}

elementSlideshowPrev.addEventListener('click', handleButtonAction(() => mySlideshow.slideshowSiema.prev()));
elementSlideshowNext.addEventListener('click', handleButtonAction(() => mySlideshow.slideshowSiema.next()));

const elementSlideshowButtons = [
  elementSlideshowPrev,
  elementSlideshowNext
];

elementSlideshowButtons.forEach((elementSlideshowButton) => {
  elementSlideshowButton.addEventListener('touchstart', () => {
    slideshowTimerPause();
  });
});

// elementSlideshowWrap.addEventListener('touchstart', () => {
//   slideshowTimerPause();
// });
elementSlideshowWrap.addEventListener('touchend', () => {
  slideshowTimerStart();
});

// elementSlideshowWrap.addEventListener('contextmenu', () => {
//   alert("contextmenu");
// });

// Event Listeners Buttons End =================

// Event Listeners End =========================

// Ensure Timer On Load Begin ==================
//   (Mobile Issue)

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    // Page is now active
    slideshowTimerStart(SLIDESHOW_AUTO_DELAY);
  } else {
    // Page is hidden, optionally pause the timer
    slideshowTimerPause();
  }
});

// Event Listeners End =========================
